var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowModalSync)?_c('b-modal',{attrs:{"width":"680px","active":_vm.isShowModalSync,"on-cancel":_vm.cancel},on:{"update:active":function($event){_vm.isShowModalSync=$event}}},[_c('div',{staticClass:"card",staticStyle:{"border-radius":"8px"}},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24da00e3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/CustomHeaderModal.vue
// module id = null
// module chunks = 